// import React from 'react';
import {
  Box,
  Button,
  // Card,
  // CardContent,
  // CardMedia,
  // Divider,
  // Divider,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Page from '../components/Page';
import { AppColors, typographyClamps } from '../utils/utils';
// import EmailIcon from '@mui/icons-material/Email';
// import PrintIcon from '@mui/icons-material/Print';
// import BuildIcon from '@mui/icons-material/Build';

const Service: React.FC = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  // const bgMaroon = '#6D0033';
  // const gold = '#C9A24B';
  // const lightGold = '#D4B45B';
  // const textGray = '#4A4A4A';

  return (
    <>
      <Page title={'Service'}>
        <Box
          component='img'
          src='/static/service_page/service_home.png'
          alt='Service Hero'
          sx={{
            width: '100%',
            height: 'auto',
            maxWidth: '100%',
            display: 'block',
          }}
        />

        <Grid
          container
          sx={{
            py: 6,
            px: '10%',
            backgroundColor: 'black',
            color: 'white',
            borderRadius: 0,
            alignItems: 'center',
          }}
          spacing={4}
        >
          {/* LEFT SECTION */}
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'column', md: 'row' }}
              spacing={4}
            >
              {/* Big Multiline Title */}
              <Typography
                sx={{
                  fontSize: typographyClamps.h4,
                  fontWeight: 800,
                  whiteSpace: isXs ? 'normal' : 'pre-line',
                  lineHeight: 1.2,
                }}
              >
                Value Your {'\n'}Trade at {'\n'}Sterling {'\n'}Auto Group
              </Typography>

              {/* Subtitle + Search */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: typographyClamps.h6,
                    fontWeight: 600,
                    color: 'gray',
                    mb: 2,
                  }}
                >
                  In just a few quick steps you can see all the similar cars to
                  yours for sale at Sterling Auto Group today!
                </Typography>

                <TextField
                  placeholder='Enter Year Make Model Trim'
                  variant='outlined'
                  fullWidth
                  sx={{
                    maxWidth: 360,
                    backgroundColor: 'white',
                    borderRadius: 999,
                    mx: { xs: 0, sm: 'auto' },
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 999,
                      '& fieldset': {
                        border: 'none',
                      },
                      '&:hover fieldset': {
                        border: 'none',
                      },
                      '&.Mui-focused fieldset': {
                        border: 'none',
                      },
                    },
                    '& .MuiInputBase-input': {
                      py: 1.2,
                      px: 3,
                    },
                  }}
                />
              </Box>
            </Stack>
          </Grid>

          {/* RIGHT SECTION */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Stack
              justifyContent='center'
              alignItems='center'
              sx={{ height: '100%' }}
            >
              <Button
                sx={{
                  borderRadius: '0 !important',
                  backgroundColor: AppColors.primaryColor,
                  color: 'white',
                  textTransform: 'none',
                  padding: '6px 36px',
                  fontSize: typographyClamps.h5,
                  whiteSpace: 'pre-line',
                  lineHeight: 1.35,
                }}
                onClick={() => {}}
              >
                {'Schedule\nServices'}
              </Button>
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: 'white',
            color: 'black',
            px: '10%',
            pt: 6,
            borderRadius: 2,
            mt: 4,
          }}
        >
          <Typography
            variant='h5'
            sx={{ fontWeight: 800, mb: 2 }}
          >
            Schedule Service & Repairs with Sterling Auto Group
          </Typography>

          <Typography sx={{ mb: 3 }}>
            Schedule service and repairs for your vehicle at the Sterling Auto
            Group Service Center. Our certified service team is equipped with
            advanced diagnostics, factory-grade tools, and the expert care your
            vehicle deserves. When you're ready for service, contact our team
            and we'll help you schedule an appointment at a time that works best
            for you.
          </Typography>

          <Typography
            variant='h6'
            sx={{ fontWeight: 700, mt: 3, mb: 1 }}
          >
            Mobile Service & Concierge Pickup
          </Typography>

          <Typography sx={{ mb: 3 }}>
            While we offer full service at the Sterling Auto Group Service
            Center, that's not the only way we support you. Our service team can
            assist wherever you are in the area. Whether you live near downtown,
            the surrounding suburbs, or commute across the region, we offer
            convenient pickup and delivery options.
            <br /> We can pick up your vehicle, bring it to our service
            facility, and return it once service is complete. For select
            maintenance needs, our mobile service van may even be able to meet
            you on-site. Please note: mobile service is limited to specific
            maintenance items; more extensive repairs may require bringing your
            vehicle into our service bays.
          </Typography>

          <Typography
            variant='h6'
            sx={{ fontWeight: 700, mt: 3, mb: 1 }}
          >
            Courtesy Loaner Vehicles Available
          </Typography>

          <Typography sx={{ mb: 3 }}>
            Need to stay on the move? Sterling Auto Group offers courtesy loaner
            vehicles for qualifying service visits. Whether you're heading to
            work, an appointment, or simply need reliable transportation during
            your repair, our team can arrange a loaner that fits your day.{' '}
            <br /> Just let us know your schedule and vehicle preference, and
            we'll do our best to accommodate you.
          </Typography>

          <Typography
            variant='h6'
            sx={{ fontWeight: 700, mt: 3, mb: 1 }}
          >
            Schedule Your Service with Sterling Auto Group Today
          </Typography>

          <Typography>
            Your vehicle deserves expert care and our service team is here to
            deliver it. To book a service appointment, call us directly or
            schedule online in seconds using our digital service form. Once your
            appointment time arrives, our technicians will get to work and keep
            you updated throughout the process.
            <br />
            If you have questions about your maintenance schedule, diagnostic
            needs, or repair options, our Sterling Auto Group Service Advisors
            are always here to help.
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            py: 6,
          }}
        >
          {/* <Card
            sx={{
              maxWidth: 1000,
              mx: 'auto',
              borderRadius: 2,
              boxShadow: 3,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <CardMedia
                component='img'
                image='/static/service_page/tech-working.jpg'
                alt='Technician servicing car'
                sx={{
                  width: { xs: '100%', md: 320 },
                  height: { xs: 200, md: '100%' },
                  objectFit: 'cover',
                }}
              />

              <CardContent
                sx={{
                  flex: 1,
                  p: { xs: 2, sm: 3 },
                }}
              >
                <Box
                  component='img'
                  src='/static/images/sterling_logo.png'
                  alt='Sterling Auto Group'
                  sx={{
                    height: 40,
                    mb: 1.5,
                  }}
                />

                <Typography
                  variant='h5'
                  sx={{
                    fontWeight: 700,
                    color: textGray,
                    lineHeight: 1.2,
                    mb: 1,
                  }}
                >
                  Sterling Auto Group{' '}
                  <Box
                    component='span'
                    sx={{ color: gold }}
                  >
                    Synthetic Oil and Filter Change Special
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1rem', sm: '1.1rem' },
                    mb: 0.5,
                  }}
                >
                  Now Only $129.95{' '}
                  <Box
                    component='span'
                    sx={{ fontWeight: 400 }}
                  >
                    (orig. $179.95)
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontSize: '0.875rem',
                    color: lightGold,
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Save $50 on a Sterling Auto Group Synthetic Oil and Filter
                  Change.
                </Typography>

                <Typography
                  sx={{
                    fontSize: '0.85rem',
                    color: textGray,
                    mb: 1,
                  }}
                >
                  Regular maintenance is crucial for best performance and health
                  of your vehicle.
                </Typography>

                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    color: textGray,
                    cursor: 'pointer',
                    mb: 0.25,
                  }}
                >
                  Show disclaimer ▲
                </Typography>

                <Typography
                  sx={{
                    fontSize: '0.8rem',
                    color: textGray,
                    mb: 1.5,
                  }}
                >
                  Expires: 12/31/2025
                </Typography>

                <Box
                  sx={{
                    textAlign: 'center',
                    mt: 1,
                  }}
                >
                  <Box
                    component='img'
                    src='/static/service_page/affirm_logo.png'
                    alt='Affirm'
                    sx={{ height: 40, mb: 0.5 }}
                  />
                  <Typography
                    sx={{
                      fontSize: '0.8rem',
                      color: textGray,
                    }}
                  >
                    Service Now Pay Later Pre‑Qualify Now for 0%
                  </Typography>
                </Box>
              </CardContent>
            </Box>

            <Divider />

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              sx={{
                bgcolor: bgMaroon,
              }}
            >
              <Button
                fullWidth
                startIcon={<EmailIcon />}
                sx={{
                  color: '#fff',
                  borderRadius: 0,
                  py: 1.5,
                  fontWeight: 500,
                  borderRight: { xs: 'none', sm: '1px solid #ffffff33' },
                }}
              >
                Contact Us
              </Button>
              <Button
                fullWidth
                startIcon={<PrintIcon />}
                sx={{
                  color: '#fff',
                  borderRadius: 0,
                  py: 1.5,
                  borderRight: { xs: 'none', sm: '1px solid #ffffff33' },
                  fontWeight: 500,
                }}
              >
                Print Offer
              </Button>
              <Button
                fullWidth
                startIcon={<BuildIcon />}
                sx={{
                  color: '#fff',
                  borderRadius: 0,
                  py: 1.5,
                  fontWeight: 500,
                }}
              >
                Schedule Service
              </Button>
            </Stack>
          </Card> */}
          <Box
            component='img'
            src='/static/service_page/service_contact.png'
            alt='Service Contact'
            sx={{
              width: { xs: '90%', sm: '80%' }, // adjust size
              maxWidth: '900px', // limits the max width
              // borderRadius: 2,
              // boxShadow: 3,
            }}
          />
        </Box>
      </Page>
    </>
  );
};

export default Service;
